import { authStore } from './authStore';
import toast from './toast';

export const api = {
  fetch: async (url, options = {}) => {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    if (token) {
      headers['x-token'] = token;
    }

    const response = await fetch('http://m.minqi.site:2334' + url, {
      ...options,
      headers,
    });

    const result = await response.json();

    if (result.errorCode !== 0) {
      if (result.errorCode === 401) {
        authStore.logout();
        authStore.show();
        toast.show('会话过期，请重新登录');
      } else {
        toast.show(result.message || '请求失败');
      }
      throw new Error(result.message || 'Request failed');
    }

    return result.data;
  },
};